module.exports = __webpack_public_path__ + "img/sticker_4.9fb42082.svg";